import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const Section = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    padding: ' 24px 96px 0px 96px ',
    position:'sticky',
    top:'0',
    backgroundColor:theme.palette.mode==="light" ?
    theme.palette.background.light:theme.palette.background.dark,
        borderBottom: '1px #BDBDBD solid',
    [theme.breakpoints.down('md')]: {
        padding: '24px 48px 0px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px 24px 0px  24px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 0px 0px 0px',
    },
    zIndex:'2'
}))
export const MenuSection = styled('span')(({ theme }) => ({
    width: '35%',
    [theme.breakpoints.down('lg')]: {
        width: '50%',
    },
    [theme.breakpoints.down('md')]: {
        width: '50%',
    },
    [theme.breakpoints.down('sm')]: {
        width: '70%',
    },
    [theme.breakpoints.down('xs')]: {
        width: '87%',
    },

}))
export const Ul = styled('ul')(({ theme }) => ({
    listStyle: 'none',
    padding:' 0 5px'
}))
export const Links = styled('span')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '5px'
}))
export const LinkNav = styled(Link)(({ theme }) => ({
    textDecoration: 'none',
    display: 'block',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    '& :hover': {
        color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
        fontWeight: theme.typography.fontWeightMedium,
    },
    '& .active': {
        color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
        fontWeight: theme.typography.fontWeightMedium,
    },
    [theme.breakpoints.down('sm')]: {
    fontSize: '12px'
}
}))
// export const Li = styled('li')(({ theme }) => ({
//     margin: '0',
//     fontSize: theme.typography.linkNav.fontSize,
//     fontWeight: theme.typography.linkNav.fontWeight,
//     lineHeight: theme.typography.linkNav.letterSpacing,
//     letterSpacing: theme.typography.linkNav.letterSpacing,
   
// }))